import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'synergy-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'Synergy Healthcare',
  welcomeText: '',
  fillColor: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 9805058401,
  email: 'support@synergyhealthcare.net',
  poweredByLogo: true,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/synergy/index.js